module.exports = __webpack_public_path__ + "img/CS48Q-中_09.b99a1a26.jpg";